'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LOGGING_OUT = exports.AUTH_FAILURE = exports.AUTH_COMPLETE = exports.AUTH_START = undefined;
exports.startAuth = startAuth;
exports.logout = logout;

var _Authenticator = require('../lib/app/Authenticator');

var Authenticator = _interopRequireWildcard(_Authenticator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Action Strings
var AUTH_START = exports.AUTH_START = 'AUTH_START'; /* flow */

var AUTH_COMPLETE = exports.AUTH_COMPLETE = 'AUTH_COMPLETE';
var AUTH_FAILURE = exports.AUTH_FAILURE = 'AUTH_FAILURE';
var LOGGING_OUT = exports.LOGGING_OUT = 'LOGGING_OUT';

function startAuth(pathName, termsOfServiceAccepted) {
    return function (dispatch, getState) {
        dispatch({ type: AUTH_START });

        Authenticator.authenticate(pathName, termsOfServiceAccepted, function (data) {
            dispatch({ type: AUTH_COMPLETE, data: data });
            try {
                localStorage.setItem('isLoggedIn', true);
            } catch (e) {
                console.log('error', e);
            }
        });
    };
}

function logout(redirectUrl) {
    return function (dispatch) {
        dispatch({ type: LOGGING_OUT });
        Authenticator.logout(redirectUrl);
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/web/actions/auth-info.js
// module id = 729
// module chunks = 0